import React from 'react';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import Image from 'next/image';

import ALink from 'components/basic/ALink';
import AuthFormWrapper from 'components/basic/AuthFormWrapper';
import { Modal, useModal } from 'components/complex/Modal';
import RegistrationForm from 'components/complex/forms/RegistrationForm';

import { useAppDispatch } from 'redux-store';
import { openModal } from 'redux-store/slices/ui';

import logEvent from 'analytics/logEvent';

import styles from './styles.module.scss';

export const RegistrationModal: React.FC = () => {
  const t = useTranslationAndTypograph();
  const dispatch = useAppDispatch();
  const { modalProps } = useModal({
    type: 'Registration',
    width: '800px',
    className: styles.regModalWrapper,
    background: (
      <>
        <div className={styles.bg}>
          <Image
            src="/pagesImages/auth-reg/auth-bg.png"
            width={800}
            height={704}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className={styles.bgMobile}>
          <Image
            src="/pagesImages/auth-reg/auth-bg_mobile.png"
            width={375}
            height={812}
            layout="fill"
            objectFit="cover"
          />
        </div>
      </>
    ),
    title: t(`Create an account`),
    onAfterOpen: () => {
      logEvent('Web_Register_Page_Viewed', {
        search: window.location.search || null
      });
    },
    subtitle: (
      <>
        {t('Or')}{' '}
        <ALink
          onClick={(): void => {
            dispatch(openModal({ type: 'Auth' }));
          }}
        >
          {t('log in')}
        </ALink>{' '}
        {t('if you already have one')}
      </>
    ),
  });

  let redirectUrl = '';

  if (typeof window !== 'undefined') {
    redirectUrl = modalProps.redirectUrl || window.location.href;
  }

  return (
    <Modal {...modalProps}>
      <AuthFormWrapper withoutTopPadding>
        <RegistrationForm redirectUrl={redirectUrl} />
      </AuthFormWrapper>
    </Modal>
  );
};
